import styles from './style.module.scss';

interface Props {
    step: number;
    current: number;
};

export default function Stepper(props: Props) {
    const { step, current } = props;

    return (
        <div className={styles.wrapper}>
            {Array(step).fill('').map((_, indx) => <span
                className={styles.step}
                data-is-past={indx + 1 < current}
                data-is-current={indx + 1 === current}
            />)}
        </div>
    )
}
